<template>
  <div class="w-full grid grid-flow-col grid-cols-13 gap-x-6 items-center py-6">
    <Input
      v-model="search"
      placeholder="Search an Ad by keywords"
      class="col-start-1 col-end-4"
    />
    <Select
      v-model="industry"
      placeholder="Industry"
      class="col-start-4 col-end-6"
      :options="industries"
    />
    <Select
      v-model="subindustry"
      placeholder="Subindustry"
      class="col-start-6 col-end-8"
      :options="['Other']"
    />
    <Select
      v-model="type"
      placeholder="Type"
      class="col-start-8 col-end-10"
      :options="types"
    />
    <Select
      v-model="objective"
      placeholder="Objective"
      class="col-start-10 col-end-12"
      :options="objectives"
    />
    <Select
      v-model="order_by"
      placeholder="Order By"
      class="col-start-12 col-end-14"
      :options="[
        { label: 'New', value: 'new' },
        { label: 'Brand', value: 'name' },
        { label: 'Created at', value: 'created_at' },
      ]"
    />
    <!-- <Select
      v-model="format"
      placeholder="Format"
      class="col-start-12 col-end-14"
      :options="formats"
    /> -->
    <div class="col-start-1 col-end-14 pt-4 flex text-base">
      <template
        v-for="(value, name) in {
          industry,
          subindustry,
          type,
          objective,
          format,
        }"
        :key="`filter${value}`"
      >
        <span
          class="filters__item"
          v-if="value"
          @click="removeFilterOption(name)"
        >
          <Icon name="Check" class="check w-4 h-4 mr-2" />
          <Icon name="Close" class="close w-4 h-4 mr-2" />
          {{ value }}
        </span>
      </template>
      <span
        class="filters__item"
        @click="resetFilters"
        v-if="industry || type || objective || format"
      >
        <Icon name="Refresh" class="refresh w-4 h-4 mr-2" />Reset All
      </span>
      <!-- <Button class="col-start-12 col-end-14" @click="resetFilters">Reset</Button> -->
    </div>
  </div>
</template>

<script>
import debounce from "lodash.debounce";
import { ref, computed, watch } from "vue";
import { useStore } from "vuex";
import Input from "@/components/UI/Input";
import Select from "@/components/UI/Select/index";
import Icon from "@/components/UI/Icon";
// import Button from "@/components/UI/Button";

export default {
  components: { Input, Select, Icon },
  setup() {
    const store = useStore();

    const search = ref("");
    const industry = ref("");
    const subindustry = ref("");
    const type = ref("");
    const objective = ref("");
    const format = ref("");
    const order_by = ref("");

    const industries = computed(() => store.state.industries);
    const types = computed(() => store.state.types);
    const objectives = computed(() => store.state.objectives);
    const formats = computed(() => store.state.formats);

    watch(
      search,
      debounce(() => {
        getAdvertisements();
      }, 1500)
    );

    watch([industry, subindustry, type, objective, format, order_by], () => {
      if (
        industry.value ||
        type.value ||
        objective.value ||
        format.value ||
        subindustry.value ||
        order_by.value
      )
        getAdvertisements();
    });

    const getAdvertisements = () => {
      store.commit("SET_PAGE", 0);
      store.commit("SET_ADVERTISEMENTS", null);
      store.dispatch("GET_ADVERTISEMENTS", {
        visible: true,
        search: search.value ? search.value : undefined,
        industry: industry.value ? industry.value : undefined,
        subindustry: subindustry.value ? subindustry.value : undefined,
        type: type.value ? type.value : undefined,
        objective: objective.value ? objective.value : undefined,
        format: format.value ? format.value : undefined,
        order_by: order_by.value ? order_by.value : undefined,
      });
    };

    const resetFilters = () => {
      search.value = null;
      industry.value = null;
      subindustry.value = null;
      type.value = null;
      objective.value = "";
      format.value = "";
      order_by.value = "";
      store.commit("SET_FILTERS", {});
      store.commit("SET_PAGE", 0);
      store.commit("SET_ADVERTISEMENTS", null);
      store.dispatch("GET_ADVERTISEMENTS");
    };

    const removeFilterOption = (name) => {
      switch (name) {
        case "industry":
          industry.value = null;
          break;
        case "subindustry":
          subindustry.value = null;
          break;
        case "type":
          type.value = null;
          break;
        case "objective":
          objective.value = null;
          break;
        case "format":
          format.value = null;
          break;
        default:
          break;
      }
    };

    return {
      search,
      industry,
      subindustry,
      type,
      objective,
      format,
      order_by,
      industries,
      types,
      objectives,
      formats,
      getAdvertisements,
      resetFilters,
      removeFilterOption,
    };
  },
};
</script>

<style scoped>
.filters__item {
  @apply flex border-r border-gray-600 py-0 px-3 mr-2 cursor-pointer;
}
.filters__item svg {
  transition: 0.3s;
}
.filters__item:hover .check,
.filters__item .close {
  display: none;
}
.filters__item:hover .close {
  display: block;
}
.filters__item:hover .refresh {
  transform: rotate(60deg);
}
</style>
